import {minmax, sectionToFixedMap} from '../shared.js';
import {buildNarrativeTextTimeline, getYearState} from '../animations.js';
import {queueTicker} from '../ticker.js';

const article = document.querySelector('#chapter18');

const narrativeSection = article.querySelector('#chapter18-narrative');
const narrativeFixed = sectionToFixedMap.get(narrativeSection);
const narrativeText = narrativeFixed.querySelector('.narrative-text');
const narrativeTimeline = new TimelineLite({paused: true});

const infoSection = article.querySelector('#chapter18-infographic');
const infoFixed = sectionToFixedMap.get(infoSection);
const infoGraphic = infoFixed.querySelector('svg');
const infoYears = infoGraphic.querySelectorAll('.attacks > g');
const infoDead = infoFixed.querySelector('#chapter18-dead');
const infoInjured = infoFixed.querySelector('#chapter18-injured');
const infoFootnote = infoFixed.querySelector('.footnote');
const infoTimeline = new TimelineLite({paused: true});


/**
 * Initialize chapter
 */
export function init() {
  console.log('chapter18:init');

  buildNarrativeTextTimeline(narrativeTimeline, narrativeText, 85, 'rgba(0, 0, 0, 0.0)');

  narrativeSection.addEventListener('scrub', ({detail: {vh}}) => narrativeTimeline.seek(minmax(0, vh, narrativeTimeline.duration())));

  initInfographic();
}

/**
 * Initialize infographic
 */
function initInfographic() {
  const state = {dead: 0, injured: 0, year: 0};
  const timePerAttack = 10;
  const start = 150;

  const onUpdate = () => {
    infoDead.innerHTML = Math.round(state.dead).toLocaleString();
    infoInjured.innerHTML = Math.round(state.injured).toLocaleString();
  };

  TweenLite.set(infoFootnote, {opacity: 0});

  infoTimeline.to({}, start, {});

  for (const infoYear of infoYears) {
    const attacks = Array.from(infoYear.querySelectorAll('.attack'));
    const yearState = getYearState(infoYear);

    for (const attack of attacks) {
      const circle = attack.querySelector('circle');
      TweenLite.set(attack, {opacity: 0, scale: 0, transformOrigin: '50% 50%'});
      TweenLite.set(circle, {fill: 'rgb(255,255,255)'});
    }

    infoTimeline.call(() => TweenLite.set(state, {year: yearState.year, onComplete: () => queueTicker(Math.trunc(yearState.year))}));

    const yearStart = infoTimeline.duration();
    for (const attack of attacks) {
      infoTimeline.add([
        TweenLite.to(attack, timePerAttack / 2, {opacity: 1}),
        TweenLite.to(attack, timePerAttack, {scale: 1, ease: Back.easeOut}),
        TweenLite.to(attack.querySelector('circle'), timePerAttack, {fill: 'rgb(0,0,0)'}),
      ]);
    }
    infoTimeline.to(state, infoTimeline.duration() - yearStart, Object.assign(yearState, {onUpdate}), yearStart);

    // infoTimeline.call(() => TweenLite.to(state, 0.25, Object.assign(yearState, {onUpdate})));

    infoTimeline.call(() => TweenLite.set(state, {year: yearState.year, onComplete: () => queueTicker(Math.trunc(yearState.year))}));
  }

  infoTimeline.to(infoFootnote, 25, {opacity: 1}, 100);

  infoSection.addEventListener('scrub', ({detail: {vh}}) => infoTimeline.seek(minmax(0, vh, infoTimeline.duration()), false));
}
